// i18n area 'hci' — locale hy-AM (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.hy-AM.meta.json.
import type { enUS } from './hci'

export const hyAM: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph կլաստերներ',
      createButton: 'Ստեղծել Ceph կլաստեր',
      emptyTitle: 'Կառավարվող Ceph կլաստեր դեռ չկա',
      emptyBody: 'TVirt-ը տեղակայում և տնօրինում է Ceph-ը անդամ հանգույցների վրա՝ հիպերկոնվերգենտ VM ծանրաբեռնվածության հետ։ Ստեղծեք կլաստեր. առաջին մոնիտորը և նրա մենեջերը ինքնաբերաբար ծնվում են ընտրված կառավարման հանգույցի վրա — ապա աճեցրեք այն այլ մոնիտորներով և OSD սարքերով։',
      pageTitle: 'Ceph կլաստերներ',
      colState: 'Վիճակ',
      colMembers: 'Անդամներ',
      colSize: 'Չափ',
      colVersion: 'Ceph տարբերակ',
      sizeCell: '{used} GiB օգտագործված {total} GiB ընդհանուրից',
      phase: {
        'not-deployed': 'Տեղակայված չէ',
        deploying: 'Տեղակայվում է',
        healthy: 'Առողջ',
        degraded: 'Դեգրադացված',
        error: 'Սխալ',
        destroying: 'Ոչնչացվում է',
        destroyed: 'Ոչնչացված'
      },
      health: {
        HEALTH_OK: 'Առողջ (HEALTH_OK)',
        HEALTH_WARN: 'Նախազգուշացումներով (HEALTH_WARN)',
        HEALTH_ERR: 'Սխալի մեջ (HEALTH_ERR)',
        unknown: 'Դեռ չի դիտարկվել',
        observedAt: 'դիտարկվել է {time}'
      },
      create: {
        title: 'Ստեղծել Ceph կլաստեր',
        info: 'Նոր Ceph կլաստեր ստեղծելիս ընտրում եք առաջին հանգույցը, որի վրա կտեղադրվեն MON և MGR դերերը։ Պետք է նաև նշել, թե որ ենթացանցն օգտագործել Ceph թրաֆիկի համար. public ենթացանցն օգտագործվում է ընդհանուր ցանցային թրաֆիկի համար, մինչդեռ cluster ենթացանցը՝ OSD-ների միջև ներքին ռեպլիկաների համար. տարբեր ենթացանցեր պարտադիր չեն։',
        controlNode: 'Կառավարման հանգույց',
        controlNodeHint: 'Անդամ հանգույցը, որտեղ ծնվում են առաջին MON + MGR-ը։',
        publicSubnet: 'Public ենթացանց',
        publicSubnetHint: 'IPAM-ում գրանցված Subnet — Ceph-ի public_network-ը։ Ստեղծումից հետո անփոփոխ։',
        clusterSubnet: 'Cluster ենթացանց',
        clusterSubnetHint: 'IPAM-ում գրանցված Subnet — Ceph-ի cluster_network-ը (ռեպլիկացիա/backfill)։',
        noSubnets: 'Գրանցված Subnet չկա — նախ ստեղծեք դրանք IPAM-ում',
        sameSubnet: 'Նույն ենթացանցը public և cluster թրաֆիկի համար',
        sameSubnetHint: 'Նշված = cluster ցանցը (ռեպլիկացիա/backfill) համընկնում է public-ի հետ։ Չնշված = ընտրեք նրա սեփական ենթացանցը ԵՎ կառավարման հանգույցի հասցեն նրա ներսում։',
        controlAddress: 'Կառավարման հանգույցի հասցե',
        controlAddressHint: 'Հասցե, որ IPAM-ը գիտի հանգույցի համար public ենթացանցի ներսում։',
        controlClusterAddress: 'Կառավարման հանգույցի cluster հասցեն',
        controlClusterAddressHint: 'Հասցե, որ IPAM-ը գիտի հանգույցի համար cluster ենթացանցի ներսում։',
        noAddresses: 'IPAM-ը չգիտի այս հանգույցի ոչ մի հասցե ընտրված ենթացանցի ներսում',
        started: 'Կլաստերը ստեղծված է — bootstrap-ը շարունակվում է որպես մակրոառաջադրանք. փուլն ինքն է թարմանում',
        error: 'Կլաստերը մերժվեց'
      },
      detail: {
        actions: 'Հասանելի գործողություններ',
        tabOverview: 'Ընդհանուր պատկեր',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Պուլեր',
        tabObjects: 'Օբյեկտներ',
        tabCrush: 'CRUSH քարտեզ',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Ընդլայնված',
        phase: 'Փուլ',
        checksTitle: 'Ակտիվ առողջության ստուգումներ',
        noChecks: 'Ակտիվ առողջության ստուգումներ չկան',
        checkMuted: 'լռեցված',
        summaryPools: 'Պուլեր',
        summaryFilesystems: 'Ֆայլային համակարգեր',
        nodesCard: 'Հանգույցներ',
        monHint: 'Ամեն MON-ի հետ նույն տեղում աշխատում է MGR։ Երեք MON-ը խորհուրդ տրվող քվորումն է. լաբորատոր կլաստերը սկսում է մեկով։ OSD-ները և MDS-ներն ապրում են իրենց ներդիրներում։',
        monHintSplit: 'Այս կլաստերի վրա MON-ը և MGR-ը բաժանված են (Ընդլայնված). ամեն դեր սեփական անդամություն է ըստ հանգույցի։ Երեք MON-ը խորհուրդ տրվող քվորումն է. առնվազն մեկ MGR պետք է գոյություն ունենա։',
        noMons: 'Հայտարարված մոնիտոր չկա',
        addNode: 'Ավելացնել հանգույց',
        removeNode: 'Հեռացնել հանգույցը',
        removeNodeFrom: 'Հեռացնել {node} հանգույցը (նրա MON-ը և նույն տեղում գտնվող MGR-ը)',
        roleMon: 'MON դեր',
        roleMgr: 'MGR դեր',
        roleNa: 'N/A',
        roleNotObserved: 'դեռ չի դիտարկվել',
        monInQuorum: 'քվորումում',
        monOutQuorum: 'քվորումից դուրս',
        mgrActive: 'ակտիվ',
        mgrStandby: 'standby',
        addRoleMon: 'Ավելացնել MON դեր',
        removeRoleMon: 'Հեռացնել MON դերը',
        addRoleMgr: 'Ավելացնել MGR դեր',
        removeRoleMgr: 'Հեռացնել MGR դերը',
        restartMon: 'Վերագործարկել MON ծառայությունը',
        restartMgr: 'Վերագործարկել MGR ծառայությունը',
        addMon: 'Ավելացնել MON',
        removeMon: 'Հեռացնել MON',
        removeMonFrom: 'Հեռացնել MON դերը {node}-ից',
        addMgr: 'Ավելացնել MGR',
        removeMgr: 'Հեռացնել MGR',
        removeMgrFrom: 'Հեռացնել MGR դերը {node}-ից',
        addMds: 'Ավելացնել MDS',
        removeMds: 'Հեռացնել MDS',
        removeMdsFrom: 'Հեռացնել MDS դերը {node}-ից',
        mdsSection: 'Metadata սերվերներ (MDS)',
        noMds: 'Հայտարարված MDS չկա — ֆայլային համակարգը նախ մեկի կարիք ունի',
        mdsHint: 'MDS անդամությունը սեփականն է առաջին օրվանից. առանց CephFS-ի կլաստերը ոչ մեկ չի հայտարարում, մեկ ակտիվ գումարած մեկ standby լավ են սպասարկում ֆայլային համակարգը։ Ceph-ն ընտրում է ակտիվներին և standby-ներին հայտարարված դեմոնների միջից։',
        mdsActiveFor: 'ակտիվ — {fs}',
        mdsNotObserved: 'դեռ չի դիտարկվել',
        lastMdsGuard: 'Վերջին MDS-ը հնարավոր չէ հեռացնել, քանի դեռ ֆայլային համակարգ գոյություն ունի — նախ հեռացրեք ֆայլային համակարգերը',
        lastMonGuard: 'Վերջին MON-ը հնարավոր չէ հեռացնել — կլաստերի ոչնչացումը միակ ելքն է',
        lastMgrGuard: 'Վերջին MGR-ը հնարավոր չէ հեռացնել — կառավարվող կլաստերը երբեք չի աշխատում առանց մենեջերի',
        registerDevice: 'Ավելացնել OSD',
        unregisterDevice: 'Ապագրանցել',
        activeDeviceGuard: 'Ակտիվ OSD — այն դուրս է գալիս OSD-ի կենսական ցիկլով, ոչ թե ռեգիստրից',
        colNode: 'Հանգույց',
        devicePhase: { registered: 'Գրանցված', active: 'Ակտիվ' },
        health: 'Առողջություն',
        state: 'Վիճակ',
        fsid: 'fsid',
        fsidPending: 'բացակայում է — կրկին փորձեք bootstrap-ը',
        version: 'Ceph տարբերակ',
        publicNetwork: 'Public ցանց',
        clusterNetwork: 'Cluster ցանց',
        clusterNetworkCollapsed: '= public',
        noActions: 'Այս փուլում ոչ մի գործողություն հասանելի չէ',
        destroyedNote: 'Կլաստերն ոչնչացված է — տողը շուտով ինքնաբերաբար կհեռացվի'
      },
      overview: {
        services: 'Ծառայություններ',
        ok: 'առողջ',
        warning: 'նախազգուշացում',
        down: 'պառկած',
        pgTitle: 'PG վիճակներ',
        pgTotal: 'Ընդամենը {n} PG',
        capacityTitle: 'Տարածք',
        ioTitle: 'Ընթացիկ I/O',
        ioReadBw: 'Ընթերցման թողունակություն',
        ioWriteBw: 'Գրման թողունակություն',
        ioReadIops: 'Ընթերցման IOPS',
        ioWriteIops: 'Գրման IOPS',
        notObserved: 'դեռ չի դիտարկվել'
      },
      osd: {
        colId: 'ID',
        colClass: 'Սարքի դաս',
        colState: 'Վիճակ',
        colSize: 'Չափ',
        colPgs: 'PG-ներ',
        empty: 'OSD չկա — ավելացրեք մեկը հայտարարված տվյալների սկավառակից',
        markIn: 'Նշել IN',
        markOut: 'Նշել OUT',
        scrub: 'Կատարել scrub',
        deepScrub: 'Կատարել խորը scrub',
        restart: 'Վերագործարկել ծառայությունը',
        details: 'Մանրամասներ',
        actionGuard: 'Միայն տեղակայված կլաստերի ակտիվ OSD-ի վրա',
        inTitle: 'Նշել OSD-ն IN',
        inBody: 'osd.{id}-ը վերադառնում է տվյալների բաշխման մեջ (ceph osd in). Ceph-ը վերահավասարակշռում է տվյալները նրա վրա։',
        outTitle: 'Նշել OSD-ն OUT',
        outBody: 'osd.{id}-ը դուրս է գալիս տվյալների բաշխումից (ceph osd out). նրա տվյալները վերահավասարակշռվում են այլ տեղ, և ավելորդությունը ՆՎԱԶԱԾ է, քանի դեռ backfill-ն աշխատում է։ Ցանկացած պահի շրջելի է «Նշել IN»-ով։',
        scrubTitle: 'Պլանավորել scrub',
        scrubBody: 'Պլանավորվում է osd.{id}-ի scrub. mon-ը հերթագրում է այն, և հաջորդ անցումների PG վիճակները պատմում են արդյունքը։',
        deepScrubTitle: 'Պլանավորել խորը scrub',
        deepScrubBody: 'Պլանավորվում է osd.{id}-ի խորը scrub. բայթերը ստուգող տարբերակը — ավելի ծանր I/O-ի վրա, նույն մեխանիկան։',
        restartTitle: 'Վերագործարկել OSD ծառայությունը',
        restartBody: 'osd.{id}-ը կանգնեցվում և նորից գործարկվում է վորկերի հսկողությամբ իր հանգույցի վրա։',
        started: 'Գործողությունը սկսված է — դիտարկումն ինքն է թարմանում',
        error: 'OSD գործողությունը մերժվեց'
      },
      osdDetail: {
        title: 'OSD մանրամասներ',
        tabGeneral: 'Ընդհանուր',
        tabNetwork: 'Ցանց',
        tabDevices: 'Սարքեր',
        version: 'Տարբերակ',
        hostname: 'Հոսթի անուն',
        dataPath: 'OSD տվյալների ուղի',
        objectStore: 'OSD օբյեկտային պահոց',
        encrypted: 'Գաղտնագրված',
        yes: 'Այո',
        no: 'Ոչ',
        memory: 'Հիշողության օգտագործում (PSS)',
        pid: 'Process ID (PID)',
        front: 'Front հասցե (կլիենտ և մոնիտոր)',
        hbFront: 'Heartbeat front հասցե',
        back: 'Back հասցե (OSD)',
        hbBack: 'Heartbeat back հասցե',
        colDevice: 'Սարք',
        colType: 'Տեսակ',
        colPhysical: 'Ֆիզիկական սարք',
        colSize: 'Չափ',
        volumeTitle: 'Հատորի մանրամասներ',
        creationTime: 'Ստեղծման ամսաթիվ',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Այս OSD-ի համար սարք չի դիտարկվել'
      },
      restart: {
        title: 'Վերագործարկել ծառայությունը',
        monBody: '{node}-ի վրա MON դեմոնը կանգնեցվում և նորից գործարկվում է վորկերի հսկողությամբ։',
        mgrBody: '{node}-ի վրա MGR դեմոնը կանգնեցվում և նորից գործարկվում է վորկերի հսկողությամբ։',
        started: 'Վերագործարկումը սկսված է — դիտարկումն ինքն է թարմանում',
        error: 'Վերագործարկումը մերժվեց'
      },
      encryptionMode: {
        alwaysOn: 'Միշտ ակտիվացված (dmcrypt)',
        alwaysOff: 'Միշտ ապաակտիվացված',
        perOsd: 'Ընտրվում է ամեն OSD-ի համար',
        section: 'OSD-ների գաղտնագրում at rest',
        title: 'Փոխել OSD գաղտնագրման ռեժիմը',
        hint: 'Ինչպես են պատրաստվում ՆՈՐ OSD-ները։ Գոյություն ունեցող OSD-ները պահում են իրենց ըստ սկավառակի վիճակը. փոխելու համար OSD-ն հեռացվում և վերաստեղծվում է։',
        body: 'Ռեժիմը դառնում է «{mode}» և վերաբերում է ՄԻԱՅՆ ՆՈՐ OSD-ներին. ամեն գոյություն ունեցող OSD պահում է իր ընթացիկ գաղտնագրման վիճակը։',
        apply: 'Փոխել ռեժիմը',
        error: 'Ռեժիմի փոփոխությունը մերժվեց'
      },
      pin: {
        address: 'Public հասցե (ոչ պարտադիր ամրացում)',
        clusterAddress: 'Cluster հասցե (ոչ պարտադիր ամրացում)',
        autoPlaceholder: 'ավտոմատ {cidr} ենթացանցում',
        hint: 'Հասցեավորում ըստ դեմոնի. դատարկ = Ceph-ն ինքն է կապվում հայտարարված ցանցի ներսում. լրացված = այս դեմոնի օրինակն ամրացվում է հասցեին իր conf բաժնում։'
      },
      addMon: {
        title: 'Ավելացնել հանգույց',
        node: 'Հանգույց',
        address: 'Public հասցե',
        addressHint: 'Հանգույցի հասցեները, որ IPAM-ը գիտի public ենթացանցի ներսում — ավտոմատ, երբ գոյություն ունեցող հայտարարությունը ծածկում է հանգույցը։',
        clusterAddress: 'Cluster հասցե',
        clusterAddressHint: 'Պարտադիր է. cluster ենթացանցն առանձին է, և հանգույցը դեռ հայտարարված չէ նրա վրա։',
        noAddresses: 'IPAM-ը չգիտի այս հանգույցի ոչ մի հասցե ենթացանցի ներսում',
        error: 'MON-ի ավելացումը մերժվեց'
      },
      removeMon: {
        title: 'Հեռացնել MON',
        body: 'MON-ը և նրա հետ նույն տեղում գտնվող MGR-ը լքում են {node} հանգույցը։ Տեղակայված կլաստերի վրա դեմոնները կանգնեցվում և հեռացվում են քվորումից։',
        error: 'MON-ի հեռացումը մերժվեց'
      },
      addMgr: {
        title: 'Ավելացնել MGR',
        node: 'Հանգույց',
        hint: 'Ընդլայնված (բաժանված MON/MGR). ինքնուրույն մենեջեր է ծնվում ընտրված անդամ հանգույցի վրա՝ հանգույցին կապված առաջադրանքով։ Ceph-ի սեփական active/standby ընտրությունն ինքն է որոշում ակտիվ MGR-ը։',
        error: 'MGR-ի ավելացումը մերժվեց'
      },
      removeMgr: {
        title: 'Հեռացնել MGR',
        body: 'Ինքնուրույն MGR-ը լքում է {node} հանգույցը։ Տեղակայված կլաստերի վրա դեմոնը կանգնեցվում է, և նրա վիճակը հեռացվում. հանգույցի MON-ին (եթե կա) չեն դիպչում։',
        error: 'MGR-ի հեռացումը մերժվեց'
      },
      addMds: {
        title: 'Ավելացնել MDS',
        node: 'Հանգույց',
        hint: 'CephFS-ի metadata սերվերը. ծնվում է ընտրված անդամ հանգույցի վրա՝ հանգույցին կապված առաջադրանքով, վորկերի հսկողությամբ, ինչպես MON-ը և MGR-ը։ Ceph-ն ինքն է ընտրում ակտիվներին և standby-ներին — մեկ ակտիվ գումարած մեկ standby լավ են սպասարկում ֆայլային համակարգը։',
        error: 'MDS-ի ավելացումը մերժվեց'
      },
      removeMds: {
        title: 'Հեռացնել MDS',
        body: 'MDS-ը լքում է {node} հանգույցը։ Տեղակայված կլաստերի վրա դեմոնը կանգնեցվում է, և նրա վիճակը հեռացվում. API-ն մերժում է վերջին MDS-ը, քանի դեռ ֆայլային համակարգը նրա կարիքն ունի։',
        error: 'MDS-ի հեռացումը մերժվեց'
      },
      split: {
        title: 'Բաժանված MON/MGR',
        label: 'Թույլատրել MON և MGR տարբեր հանգույցների վրա',
        hint: 'Անջատված (լռելյայն) = վավերացված ստանդարտը. MGR-ն աշխատում է ամեն MON-ի հետ նույն տեղում, մեկ անդամություն։ Միացված = MGR-ների անդամությունը դառնում է սեփականը՝ կառավարվում է Ավելացնել/Հեռացնել MGR գործողություններով MON & MGR ներդիրում։',
        enable: 'Ակտիվացնել',
        disable: 'Ապաակտիվացնել',
        enableBody: 'MGR-ների անդամությունը դառնում է MON-ներից անկախ՝ սկզբնարկված ընթացիկ համատեղումից։ Ինքնուրույն Ավելացնել/Հեռացնել MGR գործողությունները միանում են MON & MGR ներդիրում։ Սա թուլացնում է պլատֆորմի լռելյայնը — պահեք միայն, եթե գիտեք, թե ինչու է պետք։',
        disableBody: 'Վերադարձ ստանդարտ համատեղմանը. մեկ MGR ամեն MON-ի հետ, մեկ անդամություն։ Օրինական է միայն, երբ MGR-ների անդամությունն արդեն համընկնում է MON-ների հետ — նախ հավասարեցրեք այն Ավելացնել/Հեռացնել MGR-ով, այլապես API-ն կմերժի։',
        error: 'Փոփոխությունը մերժվեց'
      },
      rawEditor: {
        title: 'Հում CRUSH խմբագրիչ',
        label: 'Ցուցադրել crushmap-ի հում խմբագրիչը CRUSH ներդիրում',
        hint: 'Անջատված (լռելյայն) = կանոնների ուղղորդված մակերեսը ստանդարտ գործիքն է։ Միացված = CRUSH ներդիրը ցուցադրում է նաև ապակոմպիլացված crushmap-ը որպես խմբագրելի տեքստ։ Պահպանումը միշտ պահանջում է sudo, կլաստերի անունը՝ որպես հաստատում, և անցնում է crushtool-ի compile + test-ով, ՄԻՆՉԵՎ կլաստերին հասնելը։'
      },
      osdFlags: {
        section: 'Գլոբալ OSD դրոշներ',
        title: 'OSD դրոշների վերասահմանում',
        notObserved: 'դեռ չեն դիտարկվել',
        standardFlowsHint: 'Պլատֆորմի ստանդարտ հոսքերը սովորական դեպքերում ինքնուրույն են կառավարում այս դրոշները (հանգույցի սպասարկումը դնում է թիրախային noout, սարքի փոխարինումն անցնում է OSD-ի կենսական ցիկլով)։ Այս բաժինը ձեռքով վերասահմանումն է այն օպերատորի համար, ով գիտի, թե ինչ է անում։',
        notDeployedGuard: 'OSD դրոշները գոյություն ունեն միայն տեղակայված կլաստերի վրա',
        set: 'Դնել դրոշը',
        unset: 'Հանել դրոշը',
        setBody: '{flag} գլոբալ դրոշը ԿԴՐՎԻ osdmap-ի վրա։ Այն մնում է, մինչև բացահայտորեն հանվի — մոռացված դրոշը դեգրադացնում է կլաստերի ինքնավերականգնումը։',
        unsetBody: '{flag} գլոբալ դրոշը ԿՀԱՆՎԻ osdmap-ից։',
        error: 'Դրոշի փոփոխությունը մերժվեց',
        flag: {
          noout: 'Ոչ մի OSD չի նշվում out տվյալների բաշխումից — վերահավասարակշռում չկա դեմոնի կորստի դեպքում',
          norebalance: 'Տվյալների վերահավասարակշռումը կասեցված է',
          nobackfill: 'Backfill-ը կասեցված է',
          norecover: 'Վերականգնումը կասեցված է',
          pause: 'Կլիենտների ԱՄԲՈՂՋ I/O-ն դադարեցված է (ընթերցում և գրում)',
          noin: 'Գործարկվող OSD-ները ավտոմատ in չեն նշվում',
          nodown: 'Անհասանելի OSD-ները down չեն նշվում — քողարկում է իրական խափանումները'
        }
      },
      pools: {
        section: 'Պուլեր',
        create: 'Ստեղծել պուլ',
        createGuard: 'Պուլերը գոյություն ունեն միայն տեղակայված կլաստերի վրա',
        notObserved: 'Պուլերի դիտարկում դեռ չկա — mon-ի անցումը հայտնում է այստեղ',
        empty: 'Կլաստերի վրա պուլ չկա',
        colName: 'Անուն',
        colReplication: 'Size / min size',
        colPgNum: 'PG-ներ',
        colApplication: 'Կիրառություն',
        colRule: 'CRUSH կանոն',
        colUsage: 'Օգտագործում',
        observedAtLabel: 'Դիտարկվել է',
        objects: '{n} օբյեկտ',
        inUseBy: 'օգտագործում է {name}-ը',
        internalGuard: 'Ceph-ի ներքին պուլ — պլատֆորմը երբեք չի ջնջում այն',
        delete: 'Ջնջել պուլը',
        deleteGuard: 'Սպառվում է {name} պահոցի կողմից — նախ ջնջեք պահոցը',
        hint: 'Միայն ռեպլիկացված պուլեր (erasure coding-ը v1-ի շրջանակից դուրս է)։ Ռեպլիկացիան ապրում է Ceph-ում. այս աղյուսակը mon-ի անցումով դիտարկված ճշմարտությունն է։',
        createTitle: 'Ստեղծել պուլ',
        createHint: 'Պուլը ծնվում է կլաստերի վրա պահանջված ռեպլիկացիայով և ակտիվացված rbd կիրառությամբ — աշխատանքն անում է MON հանգույցի վրա գործող առաջադրանքը։ Միացրեք «Առաջարկել որպես պահոց»՝ նույն ժեստով անմիջապես սպառելու համար։',
        name: 'Պուլի անուն',
        nameHint: 'DNS-անվտանգ (փոքրատառեր, թվանշաններ, գծիկներ)։',
        size: 'Ռեպլիկաներ (size)',
        sizeHint: 'Ամեն օբյեկտի պատճենները։ Լռելյայն՝ 3։',
        minSize: 'Նվազագույն ռեպլիկաներ (min_size)',
        minSizeHint: 'I/O մատուցելու նվազագույն պատճենները — հետևում է size − 1-ին, մինչև այն խմբագրեք։',
        createError: 'Պուլի ստեղծումը մերժվեց',
        deleteTitle: 'Ջնջել պուլը',
        deleteBody: '{pool} պուլը և նրա մեջ գտնվող ԱՄԵՆ օբյեկտ ոչնչացվում են անշրջելիորեն։ Հաստատելու համար մուտքագրեք պուլի անունը։',
        confirmLabel: 'Պուլի անուն',
        confirmHint: 'Հաստատելու համար մուտքագրեք պուլի անունը',
        deleteError: 'Պուլի ջնջումը մերժվեց',
        detailTitle: 'Պուլի մանրամասներ',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Ակտիվ',
        autoscalerOff: 'Ոչ ակտիվ',
        autoscalerWarn: 'Ծանուցում',
        pgNumLabel: 'PG-ների թիվը',
        pgNumCaption: 'Դիտարկված. autoscaler-ը կարող է ինքնուրույն փոխել այն — այս դաշտը գրում է ցանկություն։',
        storage: 'Կապակցված TVirt պահոց',
        addAsStorage: 'Ավելացնել որպես TVirt պահոց',
        ruleSudoHint: 'CRUSH կանոնի փոփոխությունը պահանջում է օպերատորի գաղտնաբառը։',
        updateError: 'Պուլի փոփոխությունը մերժվեց',
        updated: 'Պուլի փոփոխությունը սկսված է — դիտարկումն ինքն է թարմանում'
      },
      crush: {
        section: 'CRUSH կանոններ',
        notObserved: 'CRUSH դիտարկում դեռ չկա — mon-ի անցումը հայտնում է այստեղ',
        empty: 'Կլաստերի վրա դիտարկված կանոն չկա',
        hint: 'Կանոնը որոշում է, ՈՐՏԵՂ են ընկնում ամեն օբյեկտի պատճենները — նրա խափանման դոմենն այն միավորն է, որը կարող է խափանվել առանց տվյալներ կորցնելու։ Պուլերը ցույց են տալիս կանոնի վրա. ներկառուցված replicated_rule-ը (մեկ ռեպլիկա ամեն սերվերի) ծննդյան լռելյայնն է։',
        create: 'Ստեղծել կանոն',
        createGuard: 'CRUSH կանոնները գոյություն ունեն միայն տեղակայված կլաստերի վրա',
        createTitle: 'Ստեղծել CRUSH կանոն',
        createHint: 'Մեկ կանոն = մեկ խափանման դոմենի ընտրություն։ Կանոնը ծնվում է ռեպլիկացված՝ լռելյայն root-ի վրա — աշխատանքն անում է MON հանգույցի վրա գործող առաջադրանքը. պուլերը կապակցեք հետո՝ Պուլեր ներդիրից։',
        createError: 'Կանոնի ստեղծումը մերժվեց',
        name: 'Կանոնի անուն',
        nameHint: 'DNS-անվտանգ (փոքրատառեր, թվանշաններ, գծիկներ)։',
        domain: 'Խափանման դոմեն',
        domainChoice: {
          osd: 'Ամեն ռեպլիկա տարբեր OSD-ի վրա',
          host: 'Ամեն ռեպլիկա տարբեր սերվերի վրա',
          rack: 'Ամեն ռեպլիկա տարբեր դարակում'
        },
        domainCustom: 'Հատուկ (ձեռքով գրված քայլեր)',
        domainOther: 'Ամեն ռեպլիկա տարբեր {type}-ում',
        rackGuardHint: 'Դիտարկված հիերարխիայում rack bucket գոյություն չունի. կանոնը միևնույն է կարելի է ստեղծել, բայց ոչ մի պուլ չի կարող ցույց տալ նրա վրա, մինչև դարակ չհայտարարվի անդամ սերվերների տեղադրության մեջ (հանգույցի կարգավորումներ) — վերադասավորման առաջադրանքը կառուցում է bucket-ը, և կապակցումն ինքն է բացվում։',
        treeTitle: 'Դիտարկված հիերարխիա',
        treeNotObserved: 'Հիերարխիայի դիտարկում դեռ չկա — mon-ի անցումը հայտնում է այստեղ',
        treeOsds: '{n} OSD',
        treeHint: 'CRUSH քարտեզն այնպես, ինչպես կլաստերն է տեսնում այն. root → հայտարարված մակարդակներ → սերվերներ (host) → OSD-ներ։ Տոպոլոգիան հետևում է ամեն սերվերի հայտարարված տեղադրությանը (հանգույցի կարգավորումներ) — դիրքի փոփոխությունը վերադասավորում է այն առաջադրանքի միջոցով։',
        unplacedWarning: 'Անդամներ առանց հայտարարված դիրքի՝ {nodes} — նրանց host-երը մնում են ուղիղ root-ի տակ՝ հայտարարված տոպոլոգիայից դուրս։ Հայտարարեք դիրքը հանգույցի կարգավորումներում (նախազգուշացում է, երբեք արգելք)։',
        colName: 'Անուն',
        colDomain: 'Խափանման դոմեն',
        colPools: 'Պուլեր',
        builtinChip: 'builtin',
        builtinGuard: 'Կլաստերի լռելյայն ներկառուցված կանոնը — պլատֆորմը երբեք չի ջնջում այն',
        detailAction: 'Կանոնի մանրամասն',
        detailType: 'Տեսակ',
        backToRules: 'Կանոններ',
        ruleNotObserved: 'Կանոնների դիտարկված ցուցակն այս կանոնը չի նշում',
        noPools: 'Ոչ մի պուլ չի հեծնում այս կանոնը',
        delete: 'Ջնջել կանոնը',
        deleteTitle: 'Ջնջել CRUSH կանոնը',
        deleteBody: '{rule} կանոնը հեռացվում է կլաստերի crushmap-ից։ Ոչ մի պուլ չպետք է հեծնի այն։ Հաստատելու համար մուտքագրեք կանոնի անունը։',
        deleteGuard: 'Հեծնում է {name} պուլը — նախ վերաուղղեք պուլը',
        confirmLabel: 'Կանոնի անուն',
        confirmHint: 'Հաստատելու համար մուտքագրեք կանոնի անունը',
        deleteError: 'Կանոնի ջնջումը մերժվեց',
        changeRule: 'Փոխել CRUSH կանոնը',
        changeRuleTitle: 'Փոխել CRUSH կանոնը',
        changeRuleHint: 'Պուլը սկսում է տեղաբաշխել իր օբյեկտներն ընտրված կանոնով — Ceph-ը տեղափոխում է գոյություն ունեցող տվյալները՝ համապատասխանելու համար (լիքը պուլի վրա հետևում է վերահավասարակշռում)։',
        changeRuleError: 'Կանոնի փոփոխությունը մերժվեց',
        rule: 'CRUSH կանոն',
        rawTitle: 'Հում crushmap (ապակոմպիլացված)',
        rawWarning: 'ՎՏԱՆԳ. այս տեքստը կլաստերի տեղաբաշխման ԱՄԲՈՂՋ քաղաքականությունն է։ Սխալ քարտեզը կարող է միանգամից կոտրել բոլոր պուլերի տեղաբաշխումը։ Պահպանումը կոմպիլացնում և փորձարկում է քարտեզը crushtool-ով՝ ՄԻՆՉԵՎ ներարկելը — բայց վավեր քարտեզը միևնույն է կարող է վատ միտք լինել։',
        rawReload: 'Վերբեռնել նորից',
        rawLoading: 'Հարցումն ընթացքի մեջ է — միայն-ընթերցվող առաջադրանքն ապակոմպիլացնում է crushmap-ը…',
        rawSave: 'Պահպանել crushmap-ը',
        rawSaveTitle: 'Ներարկել crushmap-ը',
        rawSaveBody: 'Խմբագրված տեքստը փոխարինում է ԱՄԲՈՂՋ կլաստերի crushmap-ը crushtool-ի compile + test-ից հետո։ Հաստատելու համար մուտքագրեք կլաստերի անունը։',
        rawConfirmLabel: 'Կլաստերի անուն',
        rawConfirmHint: 'Հաստատելու համար մուտքագրեք {name}',
        rawError: 'Crushmap գործողությունը ձախողվեց',
        rawHint: 'Տեքստը crushtool -d ձևն է։ Կոմպիլացիայի և թեստի սխալները վերադառնում են բառ առ բառ crushtool-ից — քարտեզը չի հասնում կլաստերին, եթե երկու դարպասներից մեկը ձախողվում է։'
      },
      objects: {
        poolsSection: 'Օբյեկտների դիտարկիչ',
        poolsHint: 'Ընտրեք պուլ՝ նրա RBD պատկերները ցուցակելու համար։ Ամեն խորը ընթերցում աշխատում է որպես միայն-ընթերցվող առաջադրանք MON հանգույցի վրա — այն չի արգելափակում (և չի արգելափակվում) իրական գործողություններից։',
        deployedGuard: 'Օբյեկտների հարցումները պատասխանում են միայն տեղակայված կլաստերի վրա',
        browse: 'Թերթել օբյեկտները',
        detailAction: 'Պատկերի մանրամասն',
        backToPools: 'Պուլեր',
        backToImages: 'Պատկերներ',
        refresh: 'Թարմացնել',
        loading: 'Հարցումն ընթացքի մեջ է — միայն-ընթերցվող առաջադրանքը հարցնում է կլաստերին…',
        error: 'Հարցումը ձախողվեց',
        retry: 'Կրկին փորձել',
        notRbd: 'Պուլ «{app}» կիրառությամբ — RBD պատկերներ չի պարունակում, ուսումնասիրելու բան չկա այստեղ',
        noImages: 'Այս պուլում RBD պատկերներ չկան',
        colImage: 'Պատկեր',
        colSize: 'Չափ',
        colObjects: 'Օբյեկտներ',
        colSnapshots: 'Սնապշոթներ',
        imagesHint: 'Rbd պահոց սպառող սկավառակները պատկերներ են՝ իրենց սկավառակի id-ի անունով։ Օբյեկտների հաշիվը տրամադրվածն է (չափ / օբյեկտի չափ) — իրական օգտագործումն ապրում է պատկերի մանրամասնում։',
        infoTitle: 'Պատկեր',
        infoSize: 'Վիրտուալ չափ',
        infoObjects: 'Օբյեկտներ (տրամադրված)',
        infoObjectSize: 'Օբյեկտի չափ',
        infoPrefix: 'Օբյեկտների պրեֆիքս',
        infoFormat: 'Ձևաչափ',
        infoFeatures: 'Հատկություններ',
        usageTitle: 'Իրական օգտագործում (rbd du)',
        usageOf: '{provisioned} GiB տրամադրվածից',
        usageHint: 'Thin բնույթով. միայն գրված օբյեկտներն են բայթեր զբաղեցնում։',
        watchersTitle: 'Watcher-ներ',
        noWatchers: 'Watcher չկա — այս պահին ոչ ոք չունի այս պատկերը բաց',
        snapshotsTitle: 'RBD սնապշոթներ',
        noSnapshots: 'Այս պատկերի վրա RBD սնապշոթ չկա',
        colSnapshot: 'Սնապշոթ',
        colProtected: 'Պաշտպանված',
        colTimestamp: 'Ստեղծված',
        protected: 'պաշտպանված',
        mappingTitle: 'Ֆիզիկական տեղաբաշխում (OSD բազմություն)',
        mappingSampled: 'Նմուշ՝ {sampled} օբյեկտ {total}-ից — ազնիվ ամփոփում. մեծ պատկերների համար բազմությունը զուգամիտում է պուլի ԲՈԼՈՐ OSD-ներին (CRUSH-ը բաշխում է օբյեկտները ամբողջ պուլով)։',
        mappingComplete: 'Բոլոր օբյեկտները քարտեզագրված են ({total} {total}-ից)։',
        objectQueryTitle: 'Քարտեզագրել մեկ օբյեկտ',
        objectName: 'Օբյեկտի անուն',
        objectHint: 'RADOS օբյեկտների անունները <պրեֆիքս>.<16-hex ինդեքս> են — ceph osd map-ը պատասխանում է PG-ով և OSD եռյակներով։',
        mapObject: 'Քարտեզագրել',
        primary: 'առաջնային՝ osd.{osd}'
      },
      registerDevice: {
        title: 'Գրանցել OSD սարք',
        hint: 'Կենդանի կլաստերի վրա գրանցումը նաև ՊԱՏՐԱՍՏՈՒՄ Է սարքը. այն դառնում է BlueStore OSD՝ հանգույցին կապված ավտոմատ առաջադրանքով (երբեք դատարկ, վավերացվել է 2026-07-24)։ Սարքը պատկանում է առավելագույնը մեկ Ceph կլաստերի ամբողջ նավատորմում։',
        disk: 'Տվյալների սկավառակ',
        diskHint: 'Հանգույցի հայտարարված տվյալների սկավառակները — անուն և սերիա',
        noDeclared: 'Այս հանգույցի վրա հայտարարված տվյալների սկավառակ չկա — նախ նշեք դրանք հանգույցի լոկալ կարգավորումներում',
        serialHint: 'Սարքի սերիան — ինքնության ամրացումը',
        encrypted: 'Գաղտնագրել այս OSD-ն (dmcrypt)',
        encryptedHint: 'Ըստ OSD-ի ընտրությունը (կլաստերի ռեժիմն է «ընտրվում է ամեն OSD-ի համար»). այն սառչում է այս սկավառակի վրա գրանցման պահին — ռեժիմի հետագա փոփոխությունը երբեք չի վերագրում այն. դա անում է տողի գաղտնագրել/ապագաղտնագրել գործողությունը։',
        error: 'Գրանցումը մերժվեց'
      },
      unregisterDevice: {
        title: 'Ապագրանցել սարքը',
        body: 'Միայն ռեգիստրում. {name}-ը դադարում է լինել այս կլաստերի OSD թեկնածու։ Նրա բայթերին չեն դիպչում։',
        error: 'Ապագրանցումը մերժվեց'
      },
      deploy: {
        action: 'Կրկին փորձել տեղակայումը',
        title: 'Կրկին փորձել bootstrap-ը',
        body: 'Ծննդյան bootstrap-ը նորից է աշխատում ընթացիկ կոնֆիգուրացիայից. mon-ները գործարկվում են, ամեն գրանցված սարք պատրաստվում և ակտիվանում է որպես BlueStore OSD։ Գործողությունն աշխատում է որպես մակրոառաջադրանք — փուլն ինքն է թարմանում։',
        started: 'Bootstrap-ը սկսված է — շարունակվում է որպես մակրոառաջադրանք. փուլն ինքն է թարմանում',
        error: 'Bootstrap-ի կրկնությունը մերժվեց'
      },
      propose: {
        action: 'Առաջարկել որպես պահոց',
        title: 'Առաջարկել որպես պահոց',
        hintPool: 'Գոյություն ունեցող {name} պուլը դառնում է TVirt պահոց. պուլով սահմանափակված cephx ինքնությունն ընկնում է բանալիների պահոց, և ceph-rbd պահոցը ծնվում է պատրաստ։ Առաջարկը սպառում է պուլը — երբեք չի ստեղծում։',
        hintFs: 'Գոյություն ունեցող {name} ֆայլային համակարգը դառնում է TVirt պահոց. ֆայլային համակարգով սահմանափակված cephx ինքնությունն ընկնում է բանալիների պահոց, և cephfs պահոցը ծնվում է պատրաստ ու միակցված։ Առաջարկը սպառում է ֆայլային համակարգը — երբեք չի ստեղծում։',
        name: 'Պահոցի անուն',
        nameHint: 'DNS-1123, եզակի սկոուպում — cephx ինքնությունն անվանվում է նրա անունով։',
        path: 'Ուղի ֆայլային համակարգի ներսում',
        pathHint: 'Բացարձակ ուղի ֆայլային համակարգի ներսում, որը պահոցը միակցում է — կասկածի դեպքում՝ /։',
        alsoPropose: 'Անմիջապես առաջարկել որպես պահոց',
        alsoProposePoolHint: 'Ստեղծումից հետո նույն ժեստը առաջարկում է նորածին պուլը որպես ceph-rbd պահոց — երկու բացահայտ կանչ, մեկ երկխոսություն։',
        alsoProposeFsHint: 'Ստեղծումից հետո նույն ժեստը առաջարկում է նորածին ֆայլային համակարգը որպես cephfs պահոց — երկու բացահայտ կանչ, մեկ երկխոսություն։',
        guard: 'Առաջարկել որպես պահոց — միայն առողջ կլաստերի վրա',
        started: 'Առաջարկն ընդունված է — պահոցը նյութականացվում է. կգտնեք այն Պահոց բաժնում',
        submit: 'Ստեղծել պահոց',
        error: 'Առաջարկը մերժվեց'
      },
      fs: {
        section: 'Ֆայլային համակարգեր',
        create: 'Ստեղծել ֆայլային համակարգ',
        createGuard: 'Ֆայլային համակարգերը գոյություն ունեն միայն տեղակայված կլաստերի վրա',
        mdsFirstGuard: 'Նախ ավելացրեք MDS — ֆայլային համակարգն առանց metadata սերվերի ծնվում է անսպասարկելի',
        notObserved: 'Ֆայլային համակարգերի դիտարկում դեռ չկա — MON-ի անցումը հայտնում է այստեղ',
        empty: 'Կլաստերի վրա ֆայլային համակարգ չկա',
        colName: 'Անուն',
        colPools: 'Պուլեր',
        colMds: 'MDS',
        noActiveMds: 'ակտիվ MDS չկա',
        delete: 'Հեռացնել ֆայլային համակարգը',
        deleteGuard: 'Սպառվում է {name} պահոցի կողմից — նախ ջնջեք պահոցը',
        hint: 'Ֆայլային համակարգը տիրապետում է իր տվյալների և metadata պուլերին (cephfs.<անուն>.data / .meta). դրանք ծնվում են նրա հետ և մեռնում նրա հետ — removeFs, երբեք պուլի ջնջում ձեռքով։ Այս աղյուսակը MON-ի անցումով դիտարկված ճշմարտությունն է։',
        createTitle: 'Ստեղծել ֆայլային համակարգ',
        createHint: 'Ֆայլային համակարգը ծնվում է կլաստերի վրա իր երկու պուլերով (կիրառություն՝ cephfs) և սպասարկվում է հայտարարված MDS-ների կողմից — աշխատանքն անում է MON հանգույցի վրա գործող առաջադրանքը։ Միացրեք «Առաջարկել որպես պահոց»՝ նույն ժեստով անմիջապես սպառելու համար։',
        name: 'Ֆայլային համակարգի անուն',
        nameHint: 'DNS-անվտանգ (փոքրատառեր, թվանշաններ, գծիկներ)։',
        sizeHint: 'ԵՐԿՈՒ նորածին պուլերի ռեպլիկաները։ Լռելյայն՝ 3։',
        createError: 'Ֆայլային համակարգի ստեղծումը մերժվեց',
        deleteTitle: 'Հեռացնել ֆայլային համակարգը',
        deleteBody: '{fs} ֆայլային համակարգը և նրա մեջ գտնվող ԱՄԵՆ ֆայլ ոչնչացվում են անշրջելիորեն — նրա տվյալների և metadata պուլերը մեռնում են նրա հետ։ Հաստատելու համար մուտքագրեք ֆայլային համակարգի անունը։',
        confirmLabel: 'Ֆայլային համակարգի անուն',
        confirmHint: 'Հաստատելու համար մուտքագրեք ֆայլային համակարգի անունը',
        deleteError: 'Ֆայլային համակարգի հեռացումը մերժվեց'
      },
      destroy: {
        action: 'Ոչնչացնել',
        retryAction: 'Կրկին փորձել քանդումը',
        retryGuard: 'Ոչնչացումն ընթացքի մեջ է — կրկնությունը վերաբերում է ձախողվածին (հակառակ դեպքում lease-ը մերժում է)',
        title: 'Ոչնչացնել կլաստերը',
        body: 'Տեղակայված ենթակառուցվածքը քանդվում է. այս կլաստերի ամեն դեմոն կանգնում է, նրա համակարգային վիճակը և բանալիների պահոցի բանալիներն ազատվում են։ Քանդման հաջողությունից հետո կլաստերն ինքնաբերաբար հեռացվում է։',
        confirmLabel: 'Կլաստերի անուն',
        confirmHint: 'Հաստատելու համար մուտքագրեք կլաստերի անունը',
        wipe: 'Զրոյացնել գրանցված սարքերը',
        wipeHint: 'Նշված. ամեն գրանցված սարքի ստորագրությունները ջնջվում են — դրանց վրայի տվյալները ոչնչանում են։ Չնշված. բայթերը մնում են անձեռնմխելի, և սարքերը վերադառնում են գրանցվածի։',
        guard: 'Ոչնչացնել — ոչինչ տեղակայված չէ',
        started: 'Ոչնչացումը սկսված է — շարունակվում է որպես մակրոառաջադրանք. փուլն ինքն է թարմանում',
        error: 'Ոչնչացումը մերժվեց'
      },
      delete: {
        guard: 'Ջնջել — միայն չտեղակայված կոնֆիգուրացիա (նախ ոչնչացրեք)',
        title: 'Ջնջե՞լ {name}-ը',
        body: 'Կոնֆիգուրացիան և նրա սարքերի ռեգիստրը հեռացվում են։ Օրինական է միայն, քանի դեռ ոչինչ տեղակայված չէ։',
        error: 'Ջնջումը մերժվեց'
      }
    }
  }
}
